import { geoAlbersUsa, geoPath } from 'd3'
import * as states from '../data/us-states.json'
import type { Organization } from '../../../types'

interface StateProps {
  organization: Organization
}

const State = ({ organization }: StateProps) => {
  //@ts-ignore
  const stateGeoJson = states.default.features.find((d: unknown) => {
    //@ts-ignore
    return d.properties.name === organization.state
  })

  //prevents error if state is misspelled in data sheet and can't be found in geojson
  let projection, path, circleProjected
  if (stateGeoJson) {
    projection = geoAlbersUsa().fitSize([300, 300], {
      type: 'FeatureCollection',
      features: [stateGeoJson],
    })

    path = geoPath().projection(projection)
    circleProjected = projection([organization.long, organization.lat]) as [
      number,
      number
    ]
  }
  return (
    <svg className="w-[300px] h-[300px]">
      {stateGeoJson && path && circleProjected && (
        <>
          {' '}
          <path
            d={`${path(stateGeoJson)}`}
            className="stroke-black fill-transparent line-join-round line-cap-round"
          />
          <circle
            transform={`translate(${circleProjected.join()})`}
            className="fill-green stroke-none"
            style={{ fillOpacity: 0.59 }}
            r={18}
          />
        </>
      )}
    </svg>
  )
}
export default State
